export var ERRORS;
(function (ERRORS) {
    ERRORS[ERRORS["NULL"] = 0] = "NULL";
    ERRORS[ERRORS["METHOD_NOT_SUPPORT"] = -100] = "METHOD_NOT_SUPPORT";
    ERRORS[ERRORS["SET_TITLE_ERROR"] = 100] = "SET_TITLE_ERROR";
    ERRORS[ERRORS["SET_LEFT_BUTTON_ERROR"] = 200] = "SET_LEFT_BUTTON_ERROR";
    ERRORS[ERRORS["SET_RIGHT_BUTTON_ERROR"] = 300] = "SET_RIGHT_BUTTON_ERROR";
    ERRORS[ERRORS["TOAST_ERROR"] = 400] = "TOAST_ERROR";
    ERRORS[ERRORS["SHOW_SHARE_WINDOW_ERROR"] = 500] = "SHOW_SHARE_WINDOW_ERROR";
    ERRORS[ERRORS["SHOW_SHARE_WINDOW_CANCELED"] = 501] = "SHOW_SHARE_WINDOW_CANCELED";
    ERRORS[ERRORS["CAPTURE_ERROR"] = 600] = "CAPTURE_ERROR";
    ERRORS[ERRORS["CAPTURE_INVALID_AREA"] = 601] = "CAPTURE_INVALID_AREA";
    ERRORS[ERRORS["CAPTURE_FAILED"] = 602] = "CAPTURE_FAILED";
    ERRORS[ERRORS["CAPTURE_UPLOAD_FAILED"] = 603] = "CAPTURE_UPLOAD_FAILED";
    ERRORS[ERRORS["SHARE_AS_IMAGE_ERROR"] = 700] = "SHARE_AS_IMAGE_ERROR";
    ERRORS[ERRORS["SHARE_AS_IMAGE_CANCELED"] = 701] = "SHARE_AS_IMAGE_CANCELED";
    ERRORS[ERRORS["LOGIN_ERROR"] = 800] = "LOGIN_ERROR";
    ERRORS[ERRORS["LOGIN_CANCELED"] = 801] = "LOGIN_CANCELED";
    ERRORS[ERRORS["GET_USER_INFO_ERROR"] = 900] = "GET_USER_INFO_ERROR";
    ERRORS[ERRORS["GET_USER_INFO_NOT_LOGIN"] = 901] = "GET_USER_INFO_NOT_LOGIN";
    ERRORS[ERRORS["GET_USER_INFO_TRAIL_USER"] = 902] = "GET_USER_INFO_TRAIL_USER";
    ERRORS[ERRORS["OPEN_WEBVIEW_ERROR"] = 1000] = "OPEN_WEBVIEW_ERROR";
    ERRORS[ERRORS["GET_IMMERSE_STATUS_BAR_HEIGHT_ERROR"] = 1100] = "GET_IMMERSE_STATUS_BAR_HEIGHT_ERROR";
    ERRORS[ERRORS["CLOSE_WEBVIEW_ERROR"] = 1200] = "CLOSE_WEBVIEW_ERROR";
    ERRORS[ERRORS["PAY_ERROR"] = 1300] = "PAY_ERROR";
    ERRORS[ERRORS["PAY_FAILED"] = 1301] = "PAY_FAILED";
    ERRORS[ERRORS["PAY_BROKEN"] = 1302] = "PAY_BROKEN";
    ERRORS[ERRORS["PAY_WECHAT_UNINSTALLED"] = 1303] = "PAY_WECHAT_UNINSTALLED";
    ERRORS[ERRORS["PAY_WECHAT_VERSION_TOO_LOW"] = 1304] = "PAY_WECHAT_VERSION_TOO_LOW";
    ERRORS[ERRORS["PREVIEW_IMAGE_ERROR"] = 1400] = "PREVIEW_IMAGE_ERROR";
    ERRORS[ERRORS["CHOOSE_IMAGE"] = 1500] = "CHOOSE_IMAGE";
    ERRORS[ERRORS["CAMERA_ERROR"] = 1600] = "CAMERA_ERROR";
    ERRORS[ERRORS["CAMERA_NOT_FOUND"] = 1601] = "CAMERA_NOT_FOUND";
    ERRORS[ERRORS["UPLOAD_IMAGE_ERROR"] = 1700] = "UPLOAD_IMAGE_ERROR";
    ERRORS[ERRORS["UPLOAD_IMAGE_FAILED"] = 1701] = "UPLOAD_IMAGE_FAILED";
    ERRORS[ERRORS["JS_LOAD_COMPLETE_ERROR"] = 1800] = "JS_LOAD_COMPLETE_ERROR";
    ERRORS[ERRORS["OPEN_SCHEMA_ERROR"] = 1900] = "OPEN_SCHEMA_ERROR";
    ERRORS[ERRORS["OPEN_SCHEMA_NO_MATCHED_PAGE"] = 1901] = "OPEN_SCHEMA_NO_MATCHED_PAGE";
    ERRORS[ERRORS["SET_ON_VISIBILITY_CHANGE"] = 2000] = "SET_ON_VISIBILITY_CHANGE";
    ERRORS[ERRORS["GET_SHARE_LIST_ERROR"] = 2100] = "GET_SHARE_LIST_ERROR";
    ERRORS[ERRORS["DO_SHARE_ERROR"] = 2200] = "DO_SHARE_ERROR";
    ERRORS[ERRORS["DO_SHARE_CANCELED"] = 2201] = "DO_SHARE_CANCELED";
    ERRORS[ERRORS["BASE64_TO_LOCAL_PATH_ERROR"] = 2300] = "BASE64_TO_LOCAL_PATH_ERROR";
    ERRORS[ERRORS["LOCAL_PATH_TO_BASE64_ERROR"] = 2400] = "LOCAL_PATH_TO_BASE64_ERROR";
    ERRORS[ERRORS["GET_WEBVIEW_INFO_ERROR"] = 2500] = "GET_WEBVIEW_INFO_ERROR";
    ERRORS[ERRORS["DO_SHARE_AS_IMAGE_ERROR"] = 2600] = "DO_SHARE_AS_IMAGE_ERROR";
    ERRORS[ERRORS["DO_SHARE_AS_IMAGE_CANCELED"] = 2601] = "DO_SHARE_AS_IMAGE_CANCELED";
    ERRORS[ERRORS["SAVE_IMAGE_TO_ALBUM_ERROR"] = 2700] = "SAVE_IMAGE_TO_ALBUM_ERROR";
    ERRORS[ERRORS["SAVE_IMAGE_TO_ALBUM_NO_PERMISSION"] = 2701] = "SAVE_IMAGE_TO_ALBUM_NO_PERMISSION";
    ERRORS[ERRORS["SAVE_IMAGE_TO_ALBUM_DOWNLOAD_FAIL"] = 2702] = "SAVE_IMAGE_TO_ALBUM_DOWNLOAD_FAIL";
    ERRORS[ERRORS["SAVE_IMAGE_TO_ALBUM_SAVE_FAIL"] = 2703] = "SAVE_IMAGE_TO_ALBUM_SAVE_FAIL";
    ERRORS[ERRORS["COPY_TO_CLIPBOARD_ERROR"] = 2800] = "COPY_TO_CLIPBOARD_ERROR";
    ERRORS[ERRORS["SET_STATUS_BAR_TEXT_COLOR_ERROR"] = 3200] = "SET_STATUS_BAR_TEXT_COLOR_ERROR";
    ERRORS[ERRORS["OPEN_FULL_SCREEN_VIDEO_ERROR"] = 501] = "OPEN_FULL_SCREEN_VIDEO_ERROR";
})(ERRORS || (ERRORS = {}));
